/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react'
import React, {useContext} from 'react'
import { ThemeUI } from '../../../theme'
import { Button, Card, Text } from '../../atoms'
import { ContentSection } from '../../organisms'
import * as styles from './index.styles'
import {Context} from "../../../context/GrowthPathContext";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {update_growth_path} from "../../../redux/actions/growth-path/update_growth_path";
import {create_growth_path} from "../../../redux/actions/growth-path/create_growth_path";

const NewPreview: React.FC = () => {
  const theme = useTheme() as ThemeUI
  const navigate = useNavigate();
  const APP_URL = process.env.REACT_APP_URL
  const { formData } = useContext(Context)
  const dispatch = useDispatch()
  const token = useSelector((state: any) => state.login.access)
  let { id } = useParams();

  const handleGrowthPath = (token: any, formData: any) => {
    if (id) {
      if (!formData.image?.name) {
        formData.image = formData.image.indexOf('/media/')>-1 ? undefined : formData.image
      }
      dispatch(update_growth_path({ token, formData, navigate }))
    } else {
      dispatch(create_growth_path({ token, formData, navigate }))
    }
  }

  return (
    <ContentSection
      style={styles.root}
      header={
        <Text textType='p' weight='bold'>Vista Previa</Text>
      }
    >
      <div css={(theme: any) => styles.preview(theme)}>
        <Card style={css({ overflow: 'hidden' })}>
          <img
            src={formData.image ? (formData.image?.name ? URL.createObjectURL(formData.image): APP_URL+''+formData.image) : 'https://via.placeholder.com/600x200'}
            alt='placeholder'
            css={styles.previewImage}
          />
          <Text textType='sm' style={styles.previewTitle(theme)}>
            {formData.title}
          </Text>
          <div css={styles.previewDescription(theme)}>
            <Text textType='sm' weight='light'>
              {formData.description}
            </Text>
            <Text textType='sm' weight='light'>
              {formData.url}
            </Text>
            <Text textType='sm' weight='light'>
              {formData.category}
            </Text>
          </div>
        </Card>
      </div>
      <Button onClick={() => handleGrowthPath(token, formData)}
              disabled={!formData.title || !formData.image  || !formData.category}>
        {!id ? 'Publicar' : 'Guardar'} camino de crecimiento
      </Button>
    </ContentSection>
  )
}


export default NewPreview
